import { useRouter } from "next/router";
import { useEffect } from "react";
import { recordPageView } from "services/frontend/Segment";
import { useRoutingContext } from "contexts/new/RoutingContext";

export const useRecordPageView = () => {
  const router = useRouter();
  const routingContext = useRoutingContext();

  useEffect(() => {
    recordPageView(router.asPath, routingContext.referrer ?? "");
  }, []);
};